import Select from 'react-select';

const customStyles = {
    control: base => ({
        ...base,
        height: 34,
        minHeight: 34,
        boxShadow: "none",
        border: 0,
    })
};

const SelectComponent = (props) => {
    return (

        <Select fullwidth
            value={props.value}
            options={props.options}
            className={props.className}
            id={props.id}
            name={props.name}
            onChange={props.handleChange}
            defaultValue={props.defaultValue}
            placeholder={props.placeholder ? props.placeholder : '--Select--'}
            isDisabled={props.isDisabled}
            isOptionDisabled={props.isOptionDisabled}
            isClearable={props.isClearable ? props.isClearable : true}
            isLoading={props.isLoading ? props.isLoading : false}
            isRtl={props.isRtl ? props.isRtl : false}
            isSearchable={props.isSearchable ? props.isSearchable : true}
            styles={customStyles}
            maxMenuHeight={200}
        />

    )
}
export default SelectComponent;